import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../../parts/SvgIcon";

const WidgetManagerHeader = ({
  name,
  description,
  goBack,
  onOpenEditWidgetInfo,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <header>
      <hgroup className="mobile-hidden">
        <SvgIcon src={"/img/new-icons/back-button.svg"} onClickFn={goBack} />
        <div>
          <h3>{name}</h3>
          <p className="p4">{description}</p>
        </div>
      </hgroup>

      <button
        className="only-show-mobile edit-widget"
        role="button"
        data-button-type="outline"
        onClick={onOpenEditWidgetInfo}
      >
        <span>{t("widgets.widgetManagerHeader.editWidgetInfo")}</span>
      </button>

      <a
        href={`/actions/refresh?modal[type]=create-widget`}
        role="button"
        data-button-type="primary"
      >
        <SvgIcon src="/img/new-icons/add.svg" noFilterOnLight={true} />
        <span>{t("widgets.widgetManagerHeader.addNewWidget")}</span>
      </a>
    </header>
  );
};

export default WidgetManagerHeader;
